import { PRODUCT } from "constants/types";
import { authApi, formData } from "utils";
import { setPermission } from "services/common/actions";


export const getProductList = () => (dispatch) =>
    authApi.get('/self/products').then(res => {
      if(res.status === 200) {
        dispatch({
          type: PRODUCT.PRODUCT_LIST,
          payload: res.data.products
        })
        return res
      } else if(res.status === 401) {
        dispatch(setPermission(false))
        return null;
      } else {
        throw res
      }
    }).catch(err => {
      throw err
    })


export const getProductByID = (id) => () =>
    authApi.get(`products/unique/${id}`)
        .then(res => {
          if (res.status === 200) {
            return res
          } else if(res.status === 404) {
            return res
          } else {
            throw res
          }
        })
        .catch(err => {
          throw err
        })


const formDataWithImage = (obj) => {
    let form_data = new FormData();

    for ( let key in obj ) {
        if(key === "image"|| key === "file") {
            obj[key].map((i, index) => {
                form_data.append(`${key}[${index}]`, i);
            });
        } else {
            form_data.append(key, obj[key]);
        }

    }

    return form_data
}


export const createInfoProduct = (product) => () =>
    authApi.post("products/create", formData(product), { timeout: 0 })
        .then(res => {
            if (res.status === 200) {
                return res
            } else {
                throw res
            }
        })
        .catch(err => {
            throw err
        });

export const editInfoProduct = (product) => () => {
    return authApi.post(`products/edit`, formData(product), { timeout: 0 })
        .then(res => {
            if (res.status === 200) {
                return res
            } else {
                throw res
            }
        })
        .catch(err => {
            throw err
        })
}


export const createProduct = (product, config) => () =>
    authApi.post("products/create", formDataWithImage(product), { timeout: 0, onUploadProgress: config.onUploadProgress })
        .then(res => {
            if (res.status === 200) {
                return res
            } else {
                throw res
            }
        })
        .catch(err => {
            throw err
        });


export const editProduct = (product, config) => () => {
    return authApi.post(`products/edit`, formDataWithImage(product), { timeout: 0, onUploadProgress: config.onUploadProgress })
        .then(res => {
            if (res.status === 200) {
                return res
            } else {
                throw res
            }
        })
        .catch(err => {
            throw err
        })
}

export const getCustomersShopAction = () => () => {
    return authApi.get('/customers/dashboard').then(res => {
        return res
    }).catch(err => {
        throw err
    })
}

export const duplicateProduct = (product) => () =>
    authApi.post("/products/duplicate", formData(product)).then(res => {
      if (res.status === 200) {
        return res
      } else {
        throw res
      }
    }).catch(err => {
      throw err
    })



export const deleteProduct = (product) => () =>
    authApi.post("products/delete", formData(product)).then(res => {
      if (res.status === 200) {
        return res
      } else {
        throw res
      }
    }).catch(err => {
      throw err
    })